/**
 * Hook personnalisé pour vérifier les notifications par polling
 * 
 * Vérifie le compteur de notifications toutes les 30 secondes
 * via une simple requête HTTP GET.
 */

import { useEffect, useRef } from 'react';
import { backofficeService } from '../services/backofficeService';

export const useNotificationSSE = (onUnreadCountChange: (count: number) => void) => {
  const intervalRef = useRef<number | null>(null);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    const fetchUnreadCount = async () => {
      try {
        const count = await backofficeService.getUnreadNotificationsCount();
        if (isMountedRef.current) {
          onUnreadCountChange(count);
        }
      } catch (error) {
        // Ignorer les erreurs silencieusement (ex: déconnexion)
        console.debug('Failed to fetch unread count:', error);
      }
    };

    // Première vérification immédiate
    fetchUnreadCount();

    // Polling toutes les 30 secondes
    intervalRef.current = setInterval(fetchUnreadCount, 30000) as unknown as number;

    // Cleanup
    return () => {
      isMountedRef.current = false;
      if (intervalRef.current !== null) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [onUnreadCountChange]);

  return { isConnected: true }; // Toujours "connecté" avec le polling
};
